<template>
  <div class="filter-container">
    <div class="row">
      <div class="col-3 py-1">
        <custom-dropdown
          placeholder="Seleccione el año"
          fieldkey="value"
          fieldname="name"
        />
      </div>
      <div class="col-7 py-1">
        <custom-input
          placeholder="Escriba Número de SIE, Nombre de Estudiante o Número de Registro"
          left-icon
          icon="fa fa-search orange-icon"
        />
      </div>
      <div class="col-2 py-1">
        <action-button text="Buscar" variant="success" class="fr ml-4 px-4" />
        <action-button
          v-if="!simple"
          i="fal fa-sliders-v"
          variant="orange"
          class="fr mr-2 pl-3"
          :class="{ transparent: !advance }"
          @click="() => (advance = !advance)"
        />
      </div>
    </div>

    <div v-if="!simple && advance">
      <div class="row py-3">
        <div class="col-12">
          <span class="separator">FILTROS</span>
        </div>
      </div>

      <div class="row">
        <div class="col-3 pt-0">
          <custom-input placeholder="Referido" />
        </div>
        <div class="col-3 pt-0">
          <custom-dropdown
            placeholder="Estatus"
            fieldkey="value"
            fieldname="name"
          />
        </div>
        <div class="col-3 pt-0">
          <custom-dropdown
            placeholder="Municipio"
            fieldkey="value"
            fieldname="name"
          />
        </div>
        <div class="col-3 pt-0">
          <custom-input placeholder="Estudiante" />
        </div>
      </div>

      <div class="row">
        <div class="col-3">
          <custom-dropdown
            placeholder="Tipo de Referido"
            fieldkey="value"
            fieldname="name"
          />
        </div>
        <div class="col-3">
          <custom-dropdown
            placeholder="CAAT"
            fieldkey="value"
            fieldname="name"
          />
        </div>
        <div class="col-3">
          <custom-dropdown
            placeholder="Escuela"
            fieldkey="value"
            fieldname="name"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomDropdown from '@/components/common/CustomDropDown';
import CustomInput from '@/components/common/CustomInput';
import ActionButton from '@/components/common/ActionButton';
export default {
  name: 'FilterLocation',
  components: {
    CustomDropdown,
    CustomInput,
    ActionButton,
  },
  props: {
    simple: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    advance: false,
  }),
  methods: {},
};
</script>

<style scoped>
.filter-container {
  background-color: #f4f6f3;
  padding: 15px;
}
.separator {
  display: flex;
  align-items: center;
  text-align: center;
  color: #aab7b1;
  font: 900 14px/17px Lato;
}
.separator::before,
.separator::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #aab7b1;
}
.separator::before {
  margin-right: 0.5em;
}
.separator::after {
  margin-left: 0.5em;
}
</style>
